export const FETCH_ESHOP_HEADER_DATA_SUCCESS = 'eshop/FETCH_ESHOP_HEADER_DATA_SUCCESS';
export const IS_ESHOP_NAVANDSEARCH = 'eshop/IS_ESHOP_NAVANDSEARCH';
export const FETCH_ESHOP_HEADER_DATA_ERROR = 'eshop/FETCH_ESHOP_HEADER_DATA_ERROR';
export const IS_NOT_CANOPY = 'eshop/IS_NOT_CANOPY';
export const SET_ESHOP_KW = 'eshop/SET_ESHOP_KW';
export const LOAD_NOT_SELLER_ESHOP_HEADER = 'eshop/LOAD_NOT_SELLER_ESHOP_HEADER';
